'use client';
import Tags from "@/components/common/Tags";
import ImageGallery from "@/components/common/image-gallery";
import { PostContentFallback, useLoadPostBySlug } from "@/components/common/posts/posts.provider";
import { SimilarPosts } from "@/components/common/posts/similar-posts";
import SectionPage from "@/components/common/section-page";

export default function PostPage() {
        const {currentPost, postsBasePath} = useLoadPostBySlug("2025/11/africa-foto-fair");

    return (
        <PostContentFallback>
        <article>
            <div style={{backgroundImage: `url(${currentPost?.image})`}} className={"h-[400px] w-full bg-cover bg-center relative"}>
                <div className={"bg-bleu-marine h-[100px] w-full flex items-center justify-start absolute bottom-0"}>
                    <SectionPage sectionType={"2xl"}>
                        <h1 className={"text-white text-4xl font-exo"}>{currentPost?.title}</h1>
                    </SectionPage>
                </div>
            </div>

            <SectionPage sectionType={"xl"} className={"my-12"}>
                <div className="markdown-content text-gray-800">
                    <p className="my-4 text-normal leading-relaxed">
                        <span className="font-bold">Lieu :</span> Auditorium de l’UFR LTHR
                    </p>

                    <p className="my-4 text-normal leading-relaxed font-semibold">
                        Thème : « La sécurité au cœur de la destination : à quelles conditions ? »
                    </p>

                    <p className="my-4 text-normal leading-relaxed">
                        Madame le Directeur Général a marqué le symposium par sa vision stratégique et inspirante pour le développement touristique de la Côte d’Ivoire.
                    </p>

                    <p className="my-4 text-normal leading-relaxed font-semibold">
                        Les piliers de sa vision :
                    </p>

                    <ul className="list-disc list-inside my-4 pl-4 text-normal">
                        <li>Sécurité : fondement de la destination Côte d’Ivoire</li>
                        <li>Approche collaborative : concertation entre tous les acteurs du tourisme</li>
                        <li>Engagement collectif : offrir une expérience optimale aux visiteurs</li>
                    </ul>

                    <p className="my-4 text-normal leading-relaxed font-semibold">
                        Mots-clés : 🛡️ Sécurité · 💚 Confiance · 🌍 Attractivité
                    </p>

                        <div className={'my-8'}>
                            <ImageGallery images={
                                Array.from({ length: 1 }).map((_, index) => ({
                                src: `/images${postsBasePath}/${String(currentPost?.slug)}/accueil.jpg`,
                                alt: `image${index + 1}`,
                                width: 700,
                                height: 700,
                                }))
                            } aspectRatio={"video"} />
                            </div>
                    

                    <Tags tags={['TourismeCI', 'MalékahMouradCondé', 'SécuritéTouristique', 'SanPedro', 'CôtedIvoire', 'Côtedivoiretourisme', 'Leadership', 'TourismeDurable', 'DestinationCôteDIvoire', 'Symposium', 'MICE']} />
                </div>

                <SimilarPosts currentSlug={String(currentPost?.slug)} />
            </SectionPage>
        </article>
        </PostContentFallback>
    );
}
